import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip Cognito IDP requests (they use X-Amz-Target, not Bearer)
  const cognitoUrl = `https://cognito-idp.${environment.cognito.region}.amazonaws.com/`;
  if (req.url.startsWith(cognitoUrl)) {
    return next(req);
  }

  const authService = inject(AuthService);
  // API Gateway Cognito authorizer validates the ID token.
  // The ID token contains the `email` and `cognito:groups` claims
  // that the Lambda reads for authorization and audit logging.
  const token = authService.getIdToken();

  if (token) {
    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next(authReq);
  }

  return next(req);
};
